<template lang="pug">
Fragment
  b-row
    b-col(cols='1')
      BackArrow
    b-col(cols='11').d-flex.flex-column.align-items-start.mb-2
      h4.title Control de Inventario
      nav.breadcrumb-custom
        span Inicio
        span.separator /
        span Control de Inventario
  ListParts( @stop-loading="loading = false" )
</template>

<script>
import ListParts from '../../components/Inventory/List.vue'
import BackArrow from '../../components/UI/BackArrow.vue'

export default {
  name: 'Inventario',
  components: {
    ListParts,
    BackArrow,
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  color: $samtek-black;
  font-size: 20px;
  font-weight: 700;
}

.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}

.breadcrumb-custom .separator {
  margin: 0 6px;
}

::v-deep .back-arrow {
  color: $samtek-yellow !important;
  font-size: 24px;
  border-radius: 5px;
}
</style>
